import { render, staticRenderFns } from "./Picture.vue?vue&type=template&id=143e5a80&scoped=true"
import script from "./Picture.vue?vue&type=script&lang=js"
export * from "./Picture.vue?vue&type=script&lang=js"
import style0 from "./Picture.vue?vue&type=style&index=0&id=143e5a80&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_d4iazq3oduqb2szvpffvlcs4f4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143e5a80",
  null
  
)

export default component.exports